import React from "react";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import { useEffect } from "react";
import { SnackbarContent, Typography, useTheme } from "@mui/material";
function ToastCustomise({
  text,
  openToast,
  setOpenToast,
  key,
  setToastText,
  color,
  style,
  gutter,
  horizontal,
  closeing,
}) {
  const theme = useTheme();
  const array = Array.isArray(text);
  const handleClose = () => {
    if (closeing) {
      closeing();
    } else {
      if (setOpenToast) setOpenToast(false);
      if (setToastText) setToastText([]);
    }
  };

  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        // style={{
        //   bottom: `${gutter ? (i + 1) * gutter : (i + 1) * 5}rem`,
        // }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: horizontal ? horizontal : "left",
        }}
        open={openToast}
        onClose={handleClose}
        //key={i}
        TransitionProps={3000}
      >
        <SnackbarContent
          style={{
            width: "100%",
            display: "flex",
            flex: "1",
            background: color,
            padding: "0.5rem 1.5rem",
            ...style,
          }}
          message={
            <ul style={{  width: "100%", color: "white" ,padding:"0"}}>
              {array?text.map((item,i) => (
                <li key={i}>{item.text}</li>
              )):text}
            </ul>
          }
        />
      </Snackbar>
    </Box>
  );
}

export default ToastCustomise;
/**========================================================================
 *                             user:javad boroji        1402/12/22
 *      {text,setToastText}=is a array {text:""}texts for display in toast /define a state in parent component
 *      {openToast,setOpenToast}=a falg for controle display toast /define a state in parent component
 *       key=a string /there is no force
 *       color:toast color
 *
 *
 *========================================================================**/
